var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2683a375047c8261f4e12d981bfab661f3d7a2db"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yogreen@hardpixel"]={id:"2683a375047c8261f4e12d981bfab661f3d7a2db"};
      